import { DocumentNode, gql } from '@apollo/client'
import { IContinueLessons } from '@dtos/User'

export const FEATURED_CONTINUE_LIMIT = 5

export interface IFeaturedContinueEnrollment {
  id: string
  activatedAt: string
  status: string
  courseClassRelease: unknown
  schoolProduct: { id: string; title: string; courses: unknown[] }
  progressCard: {
    id: string
    lessonsProgresses: ({ lesson: unknown | null } & Record<string, unknown>)[]
  } | null
}

/**
 * Converte as últimas aulas vistas da matrícula no formato do "Continue" da
 * home (`user.lastViewedContents`). A seção inverte a lista para mostrar a
 * mais recente primeiro, então a saída vai da mais antiga para a mais recente.
 */
export function toFeaturedContinueLessons(
  enrollment: IFeaturedContinueEnrollment | null | undefined,
  courseId: string,
): IContinueLessons[] {
  if (!enrollment?.progressCard) return []

  const { progressCard, schoolProduct, ...enrollmentData } = enrollment

  return progressCard.lessonsProgresses
    .filter((lessonProgress) => !!lessonProgress.lesson)
    .map(
      (lessonProgress) =>
        ({
          ...lessonProgress,
          enrollment: enrollmentData,
          progressCard: { id: progressCard.id, courseId },
          schoolProduct,
        }) as unknown as IContinueLessons,
    )
    .reverse()
}

/**
 * Uma consulta com um alias por aula para o módulo de primeiro nível de cada
 * conteúdo (`rootModuleId`), que a lista da tela de aula usa (`?moduleId=`)
 * para abrir o módulo certo. O progresso só traz o `courseContentId`.
 */
export function buildContinueModulesQuery(
  items: IContinueLessons[],
  courseId: string,
  enrollmentId: string,
): DocumentNode | null {
  const fields = items
    .map((item, index) => {
      const courseContentId = item.lesson?.courseContentId
      if (!courseContentId) return null
      return `c${index}: courseContent(id: ${JSON.stringify(String(courseContentId))}, courseId: ${JSON.stringify(courseId)}, enrollmentId: ${JSON.stringify(enrollmentId)}) { id rootModuleId }`
    })
    .filter(Boolean)
  if (fields.length === 0) return null

  return gql(`query getFeaturedContinueModules {\n${fields.join('\n')}\n}`)
}

export function withContinueModuleIds(
  items: IContinueLessons[],
  data: Record<string, { rootModuleId?: number | null } | null> | undefined,
): IContinueLessons[] {
  return items.map((item, index) => {
    const rootModuleId = data?.[`c${index}`]?.rootModuleId
    return rootModuleId ? { ...item, moduleId: String(rootModuleId) } : item
  })
}
